import React from "react";
// import Slider from "react-slick";
// import anuragEng from "../../assets/CLIENTS/anuragEng.png";
// import bvc from "../../assets/CLIENTS/bvc.jpg";
// import bvces from "../../assets/CLIENTS/bvces.jpg";
// import BVCITS from "../../assets/CLIENTS/BVCITS.jpg";
// import ISTS from "../../assets/CLIENTS/ISTS.jpg";
// import methodist from "../../assets/CLIENTS/methodist.jpg";
// import mittapalli from "../../assets/CLIENTS/mittapalli.jpg";
// import PSCMR from "../../assets/CLIENTS/PSCMR.png";
// import RAMIREDDY from "../../assets/CLIENTS/RAMIREDDY.jpg";
// import RVIT from "../../assets/CLIENTS/RVIT.jpg";
// import samskruthiPharma from "../../assets/CLIENTS/samskruthiPharma.jpg";
// import samskruthiPolytech from "../../assets/CLIENTS/samskruthiPolytech.PNG";
// import SamskrutiEC from "../../assets/CLIENTS/SamskrutiEC.jpg";
// import SRKIT from "../../assets/CLIENTS/SRKIT.png";
// import swarnandhra from "../../assets/CLIENTS/swarnandhra.jpeg";
// import vignan from "../../assets/CLIENTS/vignan.png";
// import AKIT from "../../assets/client_logs/AKIT.png"
import AKIT from "../../assets/client_logs/AKIT.png";
import VIGNANITS from "../../assets/client_logs/VGNT.png";
import BVCEC from "../../assets/client_logs/BVCEC.png";
import BVTS from "../../assets/client_logs/BVCITS.png";
import BVCR from "../../assets/client_logs/BVCR.png";
import ISTS from "../../assets/client_logs/ISTS.png";
import METH from "../../assets/client_logs/METH.png";
import MGHA from "../../assets/client_logs/MGHA.png";
import MIET from "../../assets/client_logs/MIET.png";
import MREM from "../../assets/client_logs/MREM.png";
import PSCMR from "../../assets/client_logs/PSCMR.png";
import RISE from "../../assets/client_logs/RISE.png";
import RSR from "../../assets/client_logs/RSR.png";
import SMCE from "../../assets/client_logs/SMCE.png";
import SMSK from "../../assets/client_logs/SMSK.png";
import SMSKD from "../../assets/client_logs/SMSKD.png";
import SPKG from "../../assets/client_logs/SPKG.png";
import SRK from "../../assets/client_logs/SRK.png";
import SVCE from "../../assets/client_logs/SVCE.png";
import SVS from "../../assets/client_logs/SVS.png";

const OurClints = () => {
  const clients = [
    AKIT,
    VIGNANITS,
    BVCEC,
    SMSKD,
    BVTS,
    BVCR,
    ISTS,
    METH,
    MGHA,
    MIET,
    MREM,
    PSCMR,
    RISE,
    RSR,
    SMCE,
    SPKG,
    SRK,
    SVCE,
    SVS,
    SMSK,
  ];

  return (
    <div style={{ color: "black" }}>
      <br />
      <h1
        style={{
          textAlign: "center",
          margin: "20px",
          fontWeight: "bold",
          color: "black",
        }}
      >
        Our Trusted clients
      </h1>

      <marquee
      behavior="scroll"
      direction="left"
      scrollamount="15">
        <div style={{ padding: "10px", display: "flex", border: "none",gap:"2cm" }}>
          {clients.map((each) => (
            <img
            
              style={{
                width: "4.2cm",
                margin: "auto",
                height: "4.2cm",
                borderRadius: "20px",
              }}
              src={each}
              alt="Clients"
            />
          ))}
        </div>
      </marquee>
    </div>
  );
};

export default OurClints;
